<template>
  <div class="list">
    <div class="breadcrumb">
      <Breadcrumb>
        <Breadcrumb-item>老师管理</Breadcrumb-item>
        <Breadcrumb-item>正式老师(菲)</Breadcrumb-item>
      </Breadcrumb>
    </div>
    <div class="search" @keyup.enter="search">
      <Form :label-width="60" :show-message="false">
        <Row :gutter="12">
          <i-col :span="4">
            <Form-item label="外教运营">
              <Select v-model.number="queryParam.studyAdviserId" placeholder="全部"
                      @on-change="search" clearable>
                <Option v-for="item in studyAdviserList"
                        :value="item.id" :key="item.id">{{ item.nickname }}
                </Option>
              </Select>
            </Form-item>
          </i-col>
          <i-col :span="3">
            <Form-item label="类型">
              <Select v-model.number="queryParam.category" placeholder="全部"
                      @on-change="search" clearable>
                <Option v-for="item in teacherCategoryList"
                        :value="item.code" :key="item.code">{{ item.text }}
                </Option>
              </Select>
            </Form-item>
          </i-col>
          <i-col :span="4">
            <Form-item label="是否分配外教运营">
              <Select v-model.number="queryParam.isStudyAdviser" placeholder="全部"
                      @on-change="search" clearable>
                <Option value="1">已分配</Option>
                <Option value="0">未分配</Option>
              </Select>
            </Form-item>
          </i-col>
          <i-col :span="3">
            <Form-item label="口音：">
              <Select v-model.number="queryParam.accent" placeholder="全部"
                      @on-change="search" clearable>
                <Option value="1">英音</Option>
                <Option value="2">美音</Option>
                <Option value="9">其他</Option>
              </Select>
            </Form-item>
          </i-col>
          <i-col :span="3">
            <Form-item label="性别：">
              <Select v-model.number="queryParam.sex" placeholder="全部"
                      @on-change="search" clearable>
                <Option value="1">男</Option>
                <Option value="2">女</Option>
              </Select>
            </Form-item>
          </i-col>
        </Row>
        <Row :gutter="12">
          <i-col :xs="3">
            <Form-item label="老师ID" prop="id">
              <Input name="id" v-model="queryParam.id"></Input>
            </Form-item>
          </i-col>
          <i-col :xs="4">
            <Form-item label="老师昵称">
              <Input name="name" placeholder="支持模糊搜索"
                     v-model="queryParam.name"></Input>
            </Form-item>
          </i-col>
          <i-col :xs="4">
            <Form-item label="邀请人">
              <Input name="inviteTchName" placeholder="支持模糊搜索"
                     v-model="queryParam.inviteTchName"></Input>
            </Form-item>
          </i-col>
          <i-col :xs="4">
            <Form-item label="老师账号">
              <Input name="account" placeholder="支持模糊搜索"
                     v-model="queryParam.account"></Input>
            </Form-item>
          </i-col>
          <i-col :xs="3">
            <Form-item label="授课类型" prop="tchType">
              <Select v-model.number="queryParam.tchType" placeholder="全部"
                      @on-change="search" clearable data-value="-1">
                <Option value="-1">全部</Option>
                <Option value="0">未分配</Option>
                <Option value="1">外教</Option>
                <Option value="2">中教</Option>
                <Option value="3">陪练</Option>
              </Select>
            </Form-item>
          </i-col>
          <i-col :span="3">
            <Form-item label="是否允许绑定：">
              <Select v-model.number="queryParam.isCanBound" placeholder="全部"
                      @on-change="search" clearable>
                <Option value="1">是</Option>
                <Option value="0">否</Option>
              </Select>
            </Form-item>
          </i-col>
        </Row>
      </Form>

      <div class="button-container">

        <Button type="primary" :loading="searchLoading" :disable="searchLoading" icon="search"
                @click="search">搜索
        </Button>
        <Row>
          <Button type="primary" @click="downloadLeaveTemplate">下载请假模板</Button>
          <Button type="primary" @click="uploadLeaveTemplate">上传请假文件</Button>
          <Button type="primary" @click="allTeachersLeave">全体老师请假</Button>
          <Button type="primary" @click="onAssignAdviser">分配外教运营</Button>
          <Button type="primary" @click="addTch">添加老师</Button>
        </Row>
      </div>


    </div>
    <List ref="dataList" :tableColumns="visibleColumns" :reload="reload" :reloadWithPage="reloadWithPage"
          listUrl="/tch/formal/list" class="pay-list"
          :params="queryParam" :onLoading="onLoading" @on-selection-change="selectionChange"></List>

    <TchCancelOpenedTimeModal :tchId="tchId" :successCallback="searchWithPage"
                              v-model="showTchCancelOpenedTimeModal"></TchCancelOpenedTimeModal>

    <TchAddOpenedTimeModal :tchId="tchId" :successCallback="searchWithPage"
                           v-model="showTchAddOpenedTimeModal"></TchAddOpenedTimeModal>
    <TchEditOpenedTimeModal :tchId="tchId" :successCallback="searchWithPage"
                            v-model="showTchEditOpenedTimeModal"></TchEditOpenedTimeModal>

    <TchCancelRandomOpenedTimeModal :tchId="tchId" :successCallback="searchWithPage"
                                    v-model="showCancelRandomOpenedTimeModal"></TchCancelRandomOpenedTimeModal>

    <TchAddRandomOpenedTimeModal :tchId="tchId" :successCallback="searchWithPage"
                                 v-model="showTchAddRandomOpenedTimeModal"></TchAddRandomOpenedTimeModal>

    <TchLeaveModal :tchId="tchId" :substituteList="substituteList"
                   v-model="showTchLeaveModal" @getProxyClassData="showProxyClass"
                   @getCancelProxyClassData="cancelProxyClassData"></TchLeaveModal>

    <TchLeaveOfficeModal :tchId="tchId" :substituteList="substituteList"
                         v-model="showTchLeaveOfficeModal" @getProxyClassData="showProxyClass"
                         @getCancelProxyClassData="cancelProxyClassData"></TchLeaveOfficeModal>

    <ExportLeaveModal v-model="showExportLeaveModal"></ExportLeaveModal>

    <AssignTchStudyAdviserModal :successCallback="searchWithPage" :tchList="selectionTch"
                                v-model="showAssignTchStudyAdviserModal"></AssignTchStudyAdviserModal>

    <TchInsertModal :successCallback="searchWithPage" v-model="tchInsertModal"></TchInsertModal>

    <AllTeachersLeaveModal v-model="showAllTeacherLeaveModel"></AllTeachersLeaveModal>

    <tch-info-modal :value="showTchInfoModal" @on-close="showTchInfoModal=false" :tchId="tchId"
                    :successCallback="searchWithPage"></tch-info-modal>
    <EditDingDingModal :tchId="tchId" :value="showEditDingModal" @on-close="closeEditDingModal"
                       :successCallback="searchWithPage"></EditDingDingModal>
    <TeachersDingTalkModal :tchId="tchId" :value="showTeacherDingTalkModal" @on-close="closeTeacherDingTalkModal"
                           :successCallback="searchWithPage"></TeachersDingTalkModal>

    <Modal v-model="showSelectTch" title="选择代课老师">
      <Form>
        <Row :gutter="12">
          <Col span="12">
            课节时间：{{ lsnBeginTime }}
          </Col>
          <Col span="12">
            学生姓名：{{ selectTchParam.uid + '-' + selectTchParam.userNickname }}
          </Col>
        </Row>
        <Row :gutter="12">
          <Col span="12">
            学习导师：{{ selectTchParam.studyAdviserNickname }}
          </Col>
          <Col span="12">
            课程顾问：{{ selectTchParam.adviserNickname }}
          </Col>
        </Row>
        <Row :gutter="12">
          <Col span="16">
            <Form-item label="代课老师：" :label-width="80">
              <substitute-tch-select :dataL="activityList" v-model="substituteTchId"
                                     :openedId="selectTchParam.openedId"></substitute-tch-select>
            </Form-item>
          </Col>
        </Row>
      </Form>
      <div slot="footer">
        <Button type="text" size="large" @click="showSelectTch=false">取消</Button>
        <Button type="primary" size="large" @click="updateTch">保存</Button>
      </div>
    </Modal>
    <AiDrawer
      :visible.sync="aiVisible"
      :uid="aiUid"
      subject-type="TEACHER"
      :snapshot-id="aiSnapshotId"
      page-route="/tch/filipino/tchFormalList"
      default-task-type="TCH_RISK_EXPLAIN"
      @on-executed="onAiExecuted"
      @on-close="onAiClose"
    />
    <Modal width="800"
           v-model="showTchChangeModal"
           title="操作记录">
      <Table :columns="tchChangeStatusColumn" :data="tchChangeStatusList"></Table>
      <div slot="footer"></div>
    </Modal>
  </div>
</template>
<script>
import TchCancelOpenedTimeModal from './TchCancelOpenedTimeModal.vue'
import TchAddOpenedTimeModal from './TchAddOpenedTimeModal.vue'
import TchEditOpenedTimeModal from './TchEditOpenedTimeModal.vue'
import TchCancelRandomOpenedTimeModal from './TchCancelRandomOpenedTimeModal.vue'
import TchAddRandomOpenedTimeModal from './TchAddRandomOpenedTimeModal.vue'
import TchLeaveModal from './TchLeaveModal.vue'
import TchLeaveOfficeModal from './TchLeaveOfficeModal.vue'
import AssignTchStudyAdviserModal from './modal/AssignTchStudyAdviserModal.vue'
import TchInsertModal from './TchInsertModal.vue'
import TchInfoModal from './modal/TchInfoModal.vue'
import AllTeachersLeaveModal from './AllTchLeaveModal'
import EditDingDingModal from './modal/EditDingDingModal'
import TeachersDingTalkModal from './modal/TeachersDingTalkModal'
import SubstituteTchSelect from '@/components/common/SubstituteTchSelect'
import ExportLeaveModal from './ExportLeaveModal.vue'
import AiDrawer from '@/components/ai/AiDrawer'
import { fetchAiAllowed } from '@/tools/aiAccess'
import { TCH_RISK_URI, tchRiskLevelText, tchRiskLevelColor, normalizeTchRiskList } from '@/tools/aiApi'
import { fetchTchScoreMap, applyTchScoresToRows, renderTchNameWithScore } from '@/utils/tchScore'

export default {
  components: {
    ExportLeaveModal,
    TeachersDingTalkModal,
    EditDingDingModal,
    TchCancelOpenedTimeModal,
    TchAddOpenedTimeModal,
    TchEditOpenedTimeModal,
    TchCancelRandomOpenedTimeModal,
    TchAddRandomOpenedTimeModal,
    TchLeaveModal,
    TchLeaveOfficeModal,
    AssignTchStudyAdviserModal,
    TchInsertModal,
    AllTeachersLeaveModal,
    TchInfoModal,
    SubstituteTchSelect,
    AiDrawer
  },
  data() {
    let $moment = this.$moment
    let $constant = this.$constant
    return {
      uploadLeaveUrl: this.$appConfig.baseUrl + '/bookTchLeaveTime/importExe',
      fileList: [],
      headers: {},
      activityList: [],
      substituteList: [],
      lsnBeginTime: '',
      searchLoading: false,
      rankScoreSeq: 0,
      aiAllowed: false,
      aiVisible: false,
      aiUid: null,
      aiSnapshotId: null,
      riskMap: {},
      riskLoadSeq: 0,
      reload: 0,
      reloadWithPage: 0,
      showTchChangeModal: false,
      tchChangeStatusList: [],
      tchChangeStatusColumn: [
        {
          title: '修改类别',
          render: (h, params) => {
            let type = params.row.type
            let typeEnum = $constant.getEnum($constant.tchChangeStatusType, type)
            return h('span', typeEnum && typeEnum.text)
          }
        },
        {
          title: '原来状态',
          render: (h, params) => {
            let row = params.row
            let oldStatus = row.oldStatus
            let type = row.type
            if (type === 1) {
              let oldStatusEnum = $constant.getEnum($constant.teacherStatus, oldStatus)
              return h('span', oldStatusEnum && oldStatusEnum.text)
            } else if (type === 4) {
              return h('span', row.oldNickname || '')
            }
            return h('span', oldStatus)
          }
        },
        {
          title: '现在状态',
          render: (h, params) => {
            let row = params.row
            let newStatus = row.newStatus
            let type = row.type
            if (type === 1) {
              let newStatusEnum = $constant.getEnum($constant.teacherStatus, newStatus)
              return h('span', newStatusEnum && newStatusEnum.text)
            } else if (type === 4) {
              return h('span', row.newNickname || '')
            }
            return h('span', newStatus)
          }
        },
        {
          title: '操作人',
          key: 'adminNickname'
        },
        {
          title: '操作时间',
          width: 170,
          render: (h, params) => {
            let createTime = params.row.createTime
            return h('span', createTime && $moment(createTime, 'X').format('YYYY-MM-DD HH:mm:ss'))
          }
        },
        {
          title: '理由',
          key: 'remark'
        }
      ],
      showTchInfoModal: false,
      tchId: null,
      queryParam: {
        sex: '',
        accent: '',
        channel: '2',
        inviteTchName: '',
        uid: '',
        mobile: '',
        nickname: '',
        startTimeDate: '',
        endTimeDate: '',
        tchType: -1,
        isCanBound: '',
      },
      showEditDingModal: false,
      showTeacherDingTalkModal: false,
      tchInsertModal: false,
      teacherCategoryList: [{code: 2, text: '正式老师'}, {code: 1, text: '试用期老师'}, {code: 3, text: '工作人员'}],
      studyAdviserList: [],
      showTchAddOpenedTimeModal: false,
      showTchEditOpenedTimeModal: false,
      showTchCancelOpenedTimeModal: false,
      showTchAddRandomOpenedTimeModal: false,
      showCancelRandomOpenedTimeModal: false,
      showTchLeaveModal: false,
      showTchLeaveOfficeModal: false,
      showAssignTchStudyAdviserModal: false,
      showAllTeacherLeaveModel: false,
      showExportLeaveModal: false,
      selectionTch: [],
      showSelectTch: false,
      substituteTchId: '',
      selectTchParam: {
        lessonTime: '',
        name: '',
        tchStudyAdviser: '', // 学习导师
        adviser: '', // 课程顾问
        openedId: null,
        substituteTchId: ''
      },
      title: [
        {
          type: 'selection',
          width: 40,
          fixed: 'left',
          align: 'center'
        },
        {
          title: '老师ID',
          width: 80,
          fixed: 'left',
          align: 'center',
          key: 'id'
        },
        {
          title: '老师昵称',
          width: 140,
          fixed: 'left',
          align: 'center',
          render: (h, params) => {
            let row = params.row
            return renderTchNameWithScore(h, {
              text: row.firstName + row.lastName,
              score: row.monthRankScore,
              onClick: () => this.openTchInfoModal(row.id)
            })
          }
        },
        {
          title: '老师账号',
          key: 'account',
          width: 130,
          align: 'center',
        },
        {
          title: '绑定权限',
          width: 80,
          align: 'center',
          render: (h, params) => {
            let row = params.row
            let isCanBoundText = row.isCanBound === 1 ? '是' : '否'
            let style = row.isCanBound === 1 ? {} : {color: 'red'}
            return h('span', {style: style}, isCanBoundText)
          }
        },
        {
          title: '无试听权限原因',
          width: 200,
          align: 'center',
          render: (h, params) => {
            let row = params.row
            return h('Input', {
              attrs: {
                title: row.invalidListenCause || '',  // 添加title属性显示完整内容
                rows: 2  // 默认显示3行
              },
              props: {
                value: row.invalidListenCause,
                placeholder: '',
                type: 'textarea'
              },
              style: {
                resize: 'vertical'  // 允许垂直方向调整大小
              },
              on: {
                'on-blur': (event) => {
                  const newValue = event.target.value
                  if (newValue !== row.invalidListenCause) {
                    row.invalidListenCause = newValue
                    this.updateTchDirect({tchInfo: {tchId: row.id, invalidListenCause: newValue}})
                  }
                },
                'on-enter': (value) => {
                  if (value !== row.invalidListenCause) {
                    row.invalidListenCause = value
                    this.updateTchDirect({tchInfo: {tchId: row.id, invalidListenCause: value}})
                  }
                }
              }
            })
          }
        },
        {
          title: '推荐人',
          key: 'inviteTchName',
          width: 130,
          align: 'center',
        },
        {
          title: '合同开始时间',
          key: 'crtBeginTimeStr',
          width: 120,
          align: 'center',
        },
        {
          title: '合同结束时间',
          //  key: 'crtEndTimeStr',
          width: 120,
          align: 'center',
          render: (h, params) => {


            let row = params.row
            let day = row.crtEndTimeDay
            let crtEndTimeStr = row.crtEndTimeStr
            if (crtEndTimeStr) {
              if (day <= 30) {
                return h('div', [
                  h('p', {}, row.crtEndTimeStr),
                  h('span', {style: {color: 'red'}}, '距结束' + day + '天')
                ])
              } else {
                return h('div', [
                  h('p', {}, row.crtEndTimeStr),
                ])
              }
            }
          }
        },
        {
          title: '买断时间',
          width: 100,
          align: 'center',
          render: (h, params) => {
            let isOpened = params.row.isOpened
            if (isOpened) {
              return h('a', {
                on: {
                  click: () => {
                    this.tchId = params.row.id
                    this.showTchCancelOpenedTimeModal = true
                  }
                }
              }, '查看')
            } else {
              return h('span', '未添加')
            }
          }
        },
        {
          title: '上课时间',
          width: 170,
          align: 'center',
          render: (h, params) => {
            let isRandomOpened = params.row.isRandomOpened
            if (isRandomOpened) {
              return h('a', {
                on: {
                  click: () => {
                    this.tchId = params.row.id
                    this.showCancelRandomOpenedTimeModal = true
                  }
                }
              }, '查看')
            } else {
              return h('span', '未添加')
            }
          }
        },
        {
          title: '类型',
          width: 90,
          align: 'center',
          render: (h, params) => {
            let category = params.row.category
            let categoryEnum = $constant.getEnum($constant.teacherCategory, category)
            return h('span', categoryEnum && categoryEnum.text)
          }
        },
        {
          title: '外教运营',
          key: 'studyAdviserNickname',
          width: 120,
          align: 'center',

        },
        {
          title: '操作日志',
          width: 100,
          align: 'center',
          render: (h, params) => {
            let self = this
            let isTchChange = params.row.isTchChange
            let id = params.row.id
            if (isTchChange) {
              return h('a', {
                on: {
                  click: () => {
                    self.onTchChangeStatusList(id)
                  }
                }
              }, '查看')
            } else {
              return h('span', '无记录')
            }
          }
        },
        {
          title: '授课类型',
          key: 'tchType',
          width: 100,
          align: 'center',

          render: (h, params) => {
            let tchType = params.row.tchType
            let tchTypeEnum = $constant.getEnum($constant.tchType, tchType)
            return h('span', tchTypeEnum && tchTypeEnum.text)
          }
        },
        {
          title: '应急外教',
          width: 110,
          align: 'center',
          render: (h, params) => {
            let row = params.row
            return h('Select', {
              props: {
                value: row.emergency,
                transfer: true
              },
              on: {
                'on-change': (value) => {
                  // 更新数据
                  row.emergency = value
                  this.updateTchDirect({tchList: {id: row.id, emergency: value}})
                }
              }
            }, [
              h('Option', {props: {value: 1}}, '是'),
              h('Option', {props: {value: 0}}, '否')
            ])
          }
        },
        {
          title: '来源',
          width: 100,
          align: 'center',
          render: (h, params) => {
            let tchChannel = params.row.channel
            let tchChannelEnum = $constant.getEnum($constant.tchChannel, tchChannel)
            return h('div', tchChannelEnum && tchChannelEnum.text)
          }
        },
        {
          title: '风险',
          key: 'tchRisk',
          width: 70,
          align: 'center',
          render: (h, params) => {
            let row = params.row
            let snap = this.riskMap[row.id] || this.riskMap[String(row.id)]
            let level = row.riskLevel
            if (level == null && snap) {
              level = snap.level
            }
            let text = this.riskLevelText(level)
            if (!text) {
              return h('span', '—')
            }
            return h('span', {
              style: {
                color: this.riskLevelColor(level),
                fontWeight: '600'
              }
            }, text)
          }
        },
        {
          title: '操作',
          align: 'center',
          fixed: 'right',
          width: 120,
          render: (h, params) => {
            let row = params.row
            let tchType = row.tchType
            let btn = null
            if (row.category !== 3) {
              if (tchType === 2) {
                btn = h('Dropdown', {
                  props: {
                    transfer: true,
                    trigger: 'click',
                  },
                  on: {
                    'on-click': (name) => {
                      if (name === 'addOpenedTime') {
                        this.tchId = row.id
//                        this.showTchAddOpenedTimeModal = true
                      } else if (name === 'editOpenedTime') {
                        this.tchId = row.id
                        this.showTchEditOpenedTimeModal = true
                      } else if (name === 'addRandomOpenedTime') {
                        this.tchId = row.id
                        this.showTchAddRandomOpenedTimeModal = true
                      } else if (name === 'tchLeave') {
                        this.tchId = row.id
                        this.showTchLeaveModal = true
                      } else if (name === 'tchLeaveOffice') {
                        this.tchId = row.id
                        this.showTchLeaveOfficeModal = true
                      } else if (name === 'disable') {
                        this.onDisableTch(row)
                      } else if (name === 'editDing') {
                        this.tchId = row.id
                        this.showEditDingModal = true
                      }
                    }
                  }
                }, [
                  h('a', [
                    h('span', '更多 '),
                    h('Icon', {props: {type: 'ios-arrow-down'}})
                  ]),
                  h('Dropdown-menu', {slot: 'list'}, [
//                    h('Dropdown-item', { props: { name: 'addOpenedTime' } }, '添加买断时间'),
                    h('Dropdown-item', {props: {name: 'editOpenedTime'}}, '编辑买断时间'),
                    h('Dropdown-item', {props: {name: 'addRandomOpenedTime'}}, '添加上课时间'),
                    h('Dropdown-item', {props: {name: 'tchLeave'}}, '老师请假(正常)'),
                    h('Dropdown-item', {props: {name: 'tchLeaveOffice'}}, '老师离职(请假)'),
                    h('Dropdown-item', {props: {name: 'editDing'}}, '钉钉用户'),
                    h('Dropdown-item', {props: {name: 'disable'}}, '禁用'),
                    h()
                  ])
                ])
              } else {
                btn = h('Dropdown', {
                  props: {
                    transfer: true,
                    trigger: 'click',
                  },
                  on: {
                    'on-click': (name) => {
                      if (name === 'addOpenedTime') {
                        this.tchId = row.id
//                        this.showTchAddOpenedTimeModal = true
                      } else if (name === 'editOpenedTime') {
                        this.tchId = row.id
                        this.showTchEditOpenedTimeModal = true
                      } else if (name === 'addRandomOpenedTime') {
                        this.tchId = row.id
                        this.showTchAddRandomOpenedTimeModal = true
                      } else if (name === 'tchLeave') {
                        this.tchId = row.id
                        this.showTchLeaveModal = true
                      } else if (name === 'tchLeaveOffice') {
                        this.tchId = row.id
                        this.showTchLeaveOfficeModal = true
                      } else if (name === 'disable') {
                        this.onDisableTch(row)
                      } else if (name === 'editDing') {
                        this.tchId = row.id
                        this.showTeacherDingTalkModal = true
                      }
                    }
                  }
                }, [
                  h('a', [
                    h('span', '更多 '),
                    h('Icon', {props: {type: 'ios-arrow-down'}})
                  ]),
                  h('Dropdown-menu', {slot: 'list'}, [
//                    h('Dropdown-item', { props: { name: 'addOpenedTime' } }, '添加买断时间'),
                    h('Dropdown-item', {props: {name: 'editOpenedTime'}}, '编辑买断时间'),
                    h('Dropdown-item', {props: {name: 'addRandomOpenedTime'}}, '添加上课时间'),
                    h('Dropdown-item', {props: {name: 'tchLeave'}}, '老师请假(正常)'),
                    h('Dropdown-item', {props: {name: 'tchLeaveOffice'}}, '老师请假(离职)'),
                    h('Dropdown-item', {props: {name: 'editDing'}}, '钉钉用户'),
                    h('Dropdown-item', {props: {name: 'disable'}}, '禁用'),
                    h()
                  ])
                ])
              }
            } else {
              btn = h('a', {on: {}}, '禁用')
            }
            return h('div', [
              this.aiAllowed ? h('a', {
                style: {marginRight: '8px'},
                on: {click: () => this.openRiskExplain(row)}
              }, 'AI') : null,
              btn
            ])
          }
        }
      ]
    }
  },
  mounted: function () {
    let self = this
    let queryParam = this.queryParam
    queryParam.uid = this.$route.query.uid
    this.$http.post('/adminUser/listByCondition', {adminGroupId: 7, status: 1}).then(function (res) {
      if (!res || !res.data) {
        return
      }
      self.studyAdviserList = res.data
    })
  },
  created: function () {
    var self = this
    fetchAiAllowed(this.$http).then(function (allowed) {
      self.aiAllowed = !!allowed
      if (self.aiAllowed) {
        self.$nextTick(function () {
          self.loadRiskFromList()
        })
      }
    })
  },
  methods: {
    riskLevelText (level) {
      return tchRiskLevelText(level)
    },
    riskLevelColor (level) {
      return tchRiskLevelColor(level)
    },
    openRiskExplain (row) {
      if (!row || !this.aiAllowed) {
        return
      }
      var snap = this.riskMap[row.id] || this.riskMap[String(row.id)] || {}
      this.aiUid = row.id
      this.aiSnapshotId = row.riskSnapshotId || snap.snapshotId || snap.id || null
      this.aiVisible = true
    },
    loadRiskFromList () {
      var list = this.$refs.dataList
      var rows = (list && list.tableData) || []
      var ids = []
      rows.forEach(function (row) {
        if (row && row.id != null && ids.indexOf(row.id) === -1) {
          ids.push(row.id)
        }
      })
      this.loadRiskMap(ids)
    },
    loadRiskMap (tchIds) {
      var self = this
      if (!self.aiAllowed) {
        return
      }
      var seq = ++self.riskLoadSeq
      if (!tchIds || !tchIds.length) {
        self.riskMap = {}
        return
      }
      self.$http.post(TCH_RISK_URI.latestBatch, {tchIds: tchIds.join(',')}).then(function (res) {
        if (seq !== self.riskLoadSeq) {
          return
        }
        var list = []
        if (res && res.status === 'ok') {
          list = normalizeTchRiskList(res.data)
        }
        var map = {}
        list.forEach(function (item) {
          if (!item) {
            return
          }
          var id = item.tchId != null ? item.tchId : item.tch_id
          if (id == null) {
            return
          }
          var snap = {
            level: item.level,
            score: item.score,
            snapshotId: item.snapshotId != null ? item.snapshotId : item.id,
            reasonsJson: item.reasonsJson || item.reasons_json,
            calcDate: item.calcDate || item.calc_date
          }
          map[id] = snap
          map[String(id)] = snap
        })
        self.riskMap = map
        var table = self.$refs.dataList && self.$refs.dataList.tableData
        if (table && table.length) {
          table.forEach(function (row) {
            var rowSnap = map[row.id] || map[String(row.id)]
            if (rowSnap) {
              self.$set(row, 'riskLevel', rowSnap.level)
              self.$set(row, 'riskSnapshotId', rowSnap.snapshotId)
            } else {
              self.$set(row, 'riskLevel', null)
              self.$set(row, 'riskSnapshotId', null)
            }
          })
        }
      }).catch(function () {
        // ignore batch error; column stays dash
      })
    },
    onAiClose () {
      this.aiVisible = false
      this.aiUid = null
      this.aiSnapshotId = null
    },
    onAiExecuted () {
      // 写回 tch_track_record，不改变日批风险列
    },

    openTchInfoModal (val) {
      this.tchId = val
      this.showTchInfoModal = true
    },
    closeModal(val) {
      this.uid = null
      this.editUser = val
    },
    search() {
      this.reload = new Date().getTime()
    },
    searchWithPage() {
      this.reloadWithPage = new Date().getTime()
    },
    loadMonthRankScores () {
      const table = this.$refs.dataList && this.$refs.dataList.tableData
      if (!table || !table.length) {
        return
      }
      const ids = table.map(function (row) { return row.id }).filter(function (id) { return id != null })
      const seq = ++this.rankScoreSeq
      const self = this
      fetchTchScoreMap(this.$http, ids).then(function (map) {
        if (seq !== self.rankScoreSeq) {
          return
        }
        applyTchScoresToRows(self, table, 'id', 'monthRankScore', map)
      })
    },
    onLoading(loading) {
      this.searchLoading = loading
      if (!loading && this.aiAllowed) {
        this.loadRiskFromList()
      }
      if (!loading) {
        this.loadMonthRankScores()
      }
    },
    updateTchDirect (req) {
      this.$http.post('/tch/update-direct', req).then(res => {
        if (res.status === 'ok') {
          this.$Message.success('更新成功')
        } else {
          this.$Message.error(res.msg)
        }
      }).catch(() => {
        this.$Message.error('更新失败')
      })
    },
    onTchChangeStatusList(tchId) {
      let self = this
      self.tchChangeStatusList = []
      self.$http.get('/tchChangeStatus/listByCondition?tchId=' + tchId).then(function (res) {
        self.showTchChangeModal = true
        if (!res || !res.data) {
          return
        }
        self.tchChangeStatusList = res.data
      })
    },
    selectionChange(selection) {
      this.selectionTch = selection
    },
    // 分配外教运营
    onAssignAdviser() {
      if (this.selectionTch.length <= 0) {
        this.$Message.warning('请选择需分配外教运营的老师！')
        return
      }
      this.showAssignTchStudyAdviserModal = true
    },
    // 禁用老师
    onDisableTch(row) {
      let self = this
      let name = row.id + ' - ' + row.firstName + ' ' + row.lastName
      self.$Modal.confirm({
        title: '提示',
        content: '确定禁用 <b>' + name + '</b> 老师？',
        width: 300,
        loading: true,
        onOk: () => {
          self.$http.post('/tch/disable', {id: row.id}).then(function (res) {
            self.search()
            self.$Message.success('禁用成功!')
            self.$Modal.remove()
          })
        }
      })
    },
    addTch() {
      this.showTchInfoModal = true
      this.tchId = null
    },
    uploadLeaveTemplate () {
      this.showExportLeaveModal = true
    },
    downloadLeaveTemplate () {
      this.$http.get('/bookTchLeaveTime/downloadLeaveTemplate', {
        responseType: 'arraybuffer',
        params: this.queryParam
      }).then((response) => {
        if (response.data) {
          let blob = new Blob([response.data], {type: 'application/vnd.ms-excel'})
          let link = document.createElement('a')
          link.target = '_blank'
          link.href = window.URL.createObjectURL(blob)
          link.download = '请假模板.xlsx'
          link.click()
        } else {
          this.$Message.error(response.msg)
        }
      }).catch((e) => {
        console.log(e)
        this.$Message.error('下载失败')
      })
    },
    allTeachersLeave() {
      this.showAllTeacherLeaveModel = true
    },
    closeEditDingModal() {
      this.showEditDingModal = false
      this.tchId = null
    },
    closeTeacherDingTalkModal() {
      this.showTeacherDingTalkModal = false
      this.tchId = null
    },
    showProxyClass(row) {
      let self = this
      self.lsnBeginTime = this.$moment(row.lsnBeginTime, 'X').format('YYYY-MM-DD HH:mm')
      self.selectTchParam = row
      self.showSelectTch = row.show
      self.$http.get('/tch/lesson/partnerList?openedId=' + row.id).then(function (res) {
        if (res && res.data) {
          self.activityList = res.data
        } else {
          self.activityList = []
        }
      })
    },
    cancelProxyClassData(row) {
      let self = this
      row.isProxy = 0
      self.activityList.map((item, index) => {
        if (item.id == row.id) {
          self.activityList[index].replace(item, row)
        }
      })
    },
    updateTch() {
      let self = this
      self.selectTchParam.isProxy = 1
      console.log(`self.substituteTchId`, self.substituteTchId)
      if (self.substituteTchId == null || self.substituteTchId == '') {
        self.$message.warning('请选择代课老师')
        return
      }
      self.selectTchParam.substituteTchId = self.substituteTchId
      if (self.substituteList.find(item => self.selectTchParam.id == item.id) == null) {
        self.substituteList.push(self.selectTchParam)
      }
      self.showSelectTch = false
    }
  },
  computed: {
    visibleColumns () {
      if (this.aiAllowed) {
        return this.title
      }
      return this.title.filter(col => col.key !== 'tchRisk')
    }
  },
  watch: {}
}
</script>

<style scoped>
.margin {
  padding-left: 15px;
  margin-bottom: 10px;
}

.button-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.left-button {
  align-self: flex-start;
}

.right-button {
  align-self: flex-end;
}

.spacer {
  flex: 1;
}

.bg {
  background-color: red;
}
</style>



// WEBPACK FOOTER //
// TchFilipinoFormalList.vue?7f8413f7